<ng-template #loginFormTemplate>
  <!--  <form [formGroup]="valForm" class="form-validate modal-body" [class.modal-body]="!isEmbedded" role="form" name="loginForm"-->
  <form [formGroup]="valForm" class="form-validate modal-body" role="form" name="loginForm" novalidate=""
    (submit)="submitForm($event, valForm.value)">
    <div class="form-group has-feedback text-left">
      <label>Email*</label>
      <input class="form-control" id="exampleInputEmail1" type="email" name="email" placeholder="Enter email"
        pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" autocomplete="off" formControlName="email"
        required="" [(ngModel)]="_signInData.email" />
      <span class="fa fa-envelope form-control-feedback text-muted"></span>
      <span class="text-danger"
        *ngIf="valForm.controls['email'].hasError('required') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">This
        field is required</span>
      <span class="text-danger"
        *ngIf="valForm.controls['email'].hasError('email') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">This
        field must be a valid email address</span>
    </div>
    <div class="form-group has-feedback text-left">
      <label>Password*</label>
      <input class="form-control" id="exampleInputPassword1" type="password" name="password" placeholder="Password"
        formControlName="password" required="" [(ngModel)]="_signInData.password" />
      <span class="fa fa-lock form-control-feedback text-muted"></span>
      <span class="text-danger"
        *ngIf="valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)">This
        field is required</span>
    </div>

    <ng-container *ngIf="show_error">
      <div>
        <span class="text-danger">{{_output}}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="account_not_verified">
      <div>
        <span class="text-danger">{{_output}}</span>
        - <a class="btn-link" (click)="resendVerificationEmail()"><i class="fa fa-share-square"></i> Resend eMail</a>
      </div>
    </ng-container>

    <ng-container *ngIf="_userService.user_email_verified_successfully">
      <div>
        <span class="text-success">Account has been verified, you can login</span>
      </div>
    </ng-container>

    <!-- EULA Agreement Section -->
    <ng-container *ngIf="show_eula_form">
      <div class="eula-notice mt-sm mb-sm">
        <span class="text-danger">{{_output}}</span>
      </div>
      <div class="form-group has-feedback text-left mt-sm">
        <label class="eula-label">
          <input type="checkbox" [(ngModel)]="eula_agreed" [ngModelOptions]="{standalone: true}" id="eulaCheckbox" />
          <span class="ml-sm">I have read and accept the End-user License Agreement (
            <a href="javascript:void(0)" class="btn-link eula-open-link" (click)="openEulaModal()">EULA</a>
            ).</span>
        </label>
      </div>
    </ng-container>

    <div class="clearfix">
      <div class="checkbox c-checkbox pull-left mt0">
        <label>
          <input type="checkbox" value="" name="account_remember" />
          <span class="fa fa-check"></span>Remember Me</label>
      </div>
      <div class="pull-right"><a class="" [routerLink]="'/recover'">Forgot your password?</a>
      </div>
    </div>
    <button class="btn btn-secondary btn-block mt-xl fs16" type="submit"
      [disabled]="isLoggingIn || (show_eula_form && !eula_agreed)">
      <span *ngIf="!isLoggingIn">Sign in <i class="fa icon-login"></i></span>
      <span *ngIf="isLoggingIn"><i class="fa fa-spinner fa-spin mr-sm"></i> Signing in...</span>
    </button>
  </form>
  <p class="fs13">By clicking Sign in, You agree to our
    <a href="javascript:void(0)" class="policy-link" (click)="openPolicyModal('terms')">Terms of Use</a> and
    <a href="javascript:void(0)" class="policy-link" (click)="openPolicyModal('privacy')">Privacy Policy</a>
  </p>
</ng-template>

<div class="modal modal_popup d-block" *ngIf="!isEmbedded && _userService.show_login_popup">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="row">
        <div class="col-md-5">
          <div class="modal-header">
            <button class="close" (click)="trigger_login_close();"><i class="fa fa-times fs16"></i></button>
            <h4 class="text-center m0"><img src="assets/img/branding/logo-icon-green.png" alt="App Logo" /></h4>
          </div>
          <ng-container *ngTemplateOutlet="loginFormTemplate"></ng-container>
        </div>
        <div class="col-md-7 hidden-sm hidden-xs bg-img"></div>
      </div>
    </div>
  </div>
</div>
<div class="embedded-login modal_popup d-block" *ngIf="isEmbedded">

  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="row">
        <div class="col-md-5">
          <div class="modal-header">
            <button class="close" (click)="trigger_login_close();"><i class="fa fa-times fs16"></i></button>
            <h4 class="text-center m0"><img src="assets/img/branding/logo-icon-green.png" alt="App Logo" /></h4>
          </div>
          <ng-container *ngTemplateOutlet="loginFormTemplate"></ng-container>
        </div>
        <div class="col-md-1 hidden-sm hidden-xs"></div>
        <div class="col-md-7 hidden-sm hidden-xs bg-img"></div>
      </div>
    </div>
  </div>
</div>

<!-- Policy Modal -->
<div class="policy-modal-overlay" *ngIf="showPolicyModal" (click)="closePolicyModal()">
  <div class="policy-modal-dialog" (click)="$event.stopPropagation()">

    <!-- Floating close button — no header needed since WP content has its own title -->
    <button class="policy-modal-close-btn" (click)="closePolicyModal()" title="Close">
      <i class="fa fa-times"></i>
    </button>

    <div class="policy-modal-body text-left">
      <!-- Loading spinner -->
      <div class="policy-loading" *ngIf="policyLoading">
        <i class="fa fa-spinner fa-spin"></i>
        <span>Loading...</span>
      </div>
      <!-- Error state -->
      <div class="policy-error" *ngIf="policyError && !policyLoading">
        <i class="fa fa-exclamation-circle"></i>
        <p>Could not load content. <a [href]="policyFallbackUrl" target="_blank">Open in new tab</a></p>
      </div>
      <!-- WordPress page content — shortcodes stripped, internal links intercepted -->
      <div class="policy-content" *ngIf="!policyLoading && !policyError" [innerHTML]="policyContent"
        (click)="handlePolicyContentClick($event)">
      </div>
    </div>

  </div>
</div>

<!-- EULA PDF Modal — auto-opens on 406 error; closing auto-checks the agreement -->
<div class="policy-modal-overlay" *ngIf="showEulaModal" (click)="closeEulaModal()">
  <div class="policy-modal-dialog" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="eula-modal-header">
      <span><i class="fa fa-file-text-o mr-sm"></i> End-User License Agreement</span>
      <button class="close" (click)="closeEulaModal()" title="Close">
        <i class="fa fa-times fs14"></i>
      </button>
    </div>

    <!-- PDF viewer via <object>: browser renders PDF natively (no JS = no router hijack).
         The div inside is the NATIVE fallback shown when PDF cannot load. -->
    <div class="policy-modal-body">
      <object [data]="eulaUrlSafe" type="application/pdf" class="eula-pdf-object">
        <div class="policy-error">
          <i class="fa fa-file-pdf-o"></i>
          <p>PDF could not be loaded. <a href="{{_userService.eulaUrl}}" target="_blank">Open EULA in new tab</a></p>
        </div>
      </object>
    </div>

    <!-- Footer -->
    <div class="eula-modal-footer">
      <span class="text-muted fs12"><i class="fa fa-info-circle mr-sm"></i>Close this window to accept the EULA.</span>
      <button class="btn btn-secondary btn-sm" (click)="closeEulaModal()">I have read it &nbsp;<i class="fa fa-check"></i></button>
    </div>

  </div>
</div>